import { NgModule, inject } from "@angular/core";
import { RouteReuseStrategy, RouterModule } from "@angular/router";
import { PageClassService } from "./page-class.service";
import { DropRouteReuseStrategy } from "@Shared2/drop-route-reuse-strategy";
import { StartupModelRouteHandlerService } from "./startup-model-route-handler.service";
import { ModuleLoaderService } from "@Retail/module-loader.service";
import { handleSolutionChange } from "./handle-solution-change";

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: "",
                pathMatch: "full",
                redirectTo: "container",
            },
            {
                path: "billing",
                loadChildren: () => import("./billing2/billing.module").then(imported => imported.BillingModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "blog",
                loadChildren: () => import("./blog2/blog.module").then(imported => imported.BlogModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "container",
                loadChildren: () => import("./Container2/login.module").then(imported => imported.LoginModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                ],
                canActivate: [
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "elt",
                loadChildren: () => import("./elt2/elt.module").then(imported => imported.EltModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "fleet",
                loadChildren: () => import("./fleet2/fleet.module").then(imported => imported.FleetModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "insurance",
                loadChildren: () => import("./insurance2/insurance.module").then(imported => imported.InsuranceModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "interstate",
                loadChildren: () => import("./interstate2/interstate.module").then(imported => imported.InterstateModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "vitusign",
                loadChildren: () => import("./vitusign/vitusign.module").then(imported => imported.VituSignModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
            {
                path: "retail",
                loadChildren: () => import("./Retail/retail.module").then(imported => imported.RetailModule),
                canMatch: [
                    (route, segments) => handleSolutionChange(route, segments),
                    () => inject(StartupModelRouteHandlerService).initStartupModelLoading(),
                    () => inject(ModuleLoaderService).loadStateModules(),
                ],
                canActivate: [
                    () => inject(StartupModelRouteHandlerService).waitForStartupModelLoading(),
                    () => inject(ModuleLoaderService).waitForStateModules(),
                    (_, state) => inject(PageClassService).setPageClassFromUrl(state.url),
                ],
            },
        ], { scrollPositionRestoration: "top", canceledNavigationResolution: "computed" }),
    ],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: DropRouteReuseStrategy,
        },
    ],
    exports: [
        RouterModule,
    ],
})
export class AppRoutingModule {}
